export class InvalidDiscountError extends Error {}

export default class DiscountService {
  static discount = (code, quantity) =>
    fetch(`/tickets/payments/discount.json?code=${code}&quantity=${quantity}`)
      .then(response => {
        if (response.ok) {
          return response.json();
        }

        throw new InvalidDiscountError();
      });
}
